<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 652 652"
  >
    <path
      style="fill-rule: evenodd; clip-rule: evenodd; fill: #3901f1"
      class="st0"
      d="M140,321.2c0,33.1-26.8,59.9-59.9,59.9c-33.1,0-59.9-26.8-59.9-59.9c0-33.1,26.8-59.9,59.9-59.9
	C113.2,261.3,140,288.1,140,321.2L140,321.2z M56.2,344.9h29.7c0.5,0,0.7-0.6,0.5-1l-24-29.7c-0.4-0.4-0.9-0.2-1,0.2l-5.8,29.7
	C55.5,344.6,55.8,344.9,56.2,344.9L56.2,344.9z M55.6,300.1h29.7c0.4,0,0.7,0.4,0.6,0.7l-5.8,29.7c-0.1,0.5-0.7,0.6-1,0.2l-24-29.8
	C54.9,300.6,55.1,300.1,55.6,300.1L55.6,300.1z M88.3,300.5c0.1-0.2,0.3-0.5,0.6-0.5h21.4c0.4,0,0.7,0.4,0.6,0.7l-4,19.3
	c-0.1,0.3-0.3,0.5-0.6,0.5h-0.6C95.2,320.5,86.8,310.8,88.3,300.5L88.3,300.5z M88.3,300.5 M184.2,295.9h21.4c1,0,1.7,0.6,1.4,1.7
	l-1.2,6.9c4.2-6.1,10.3-9.8,16.6-9.8c3.1,0,6.4,1.2,8.2,2.9c1,1,1,1.6,0.3,2.6l-6.2,8.8c-0.8,1.1-1.3,1-2.6,0.4
	c-1.2-0.5-2.8-1-4.4-1c-7.4,0-13.7,4.9-16.6,19.7l-4.3,22.3c-0.3,1.5-1.4,1.8-2,1.8h-11.3c-0.9,0-1.7-0.8-1.4-1.8l8.4-42.9l-7.1-10
	C182.8,296.7,183.2,295.9,184.2,295.9L184.2,295.9z M184.2,295.9 M225.1,323.6c2.9-17.4,15.7-28.9,32.3-28.9
	c16.9,0,24.9,13.5,22.5,28.1c-0.6,3.8-1.9,6.8-5,6.8h-36c0.3,8.2,6,12.1,13.6,12.1c5,0,9.7-1.9,13.2-4.2c0.9-0.7,1.9-1,2.5,0
	l4.1,6.4c0.7,1,0.3,1.7-0.7,2.6c-5.3,4.9-14,7.1-21.9,7.1C232,353.6,222.4,340.5,225.1,323.6L225.1,323.6z M267,319.8
	c0.5-8.8-5.5-12.5-11.2-12.5c-7.6,0-13.4,5.1-15.7,12.5H267z M267,319.8 M333.7,350.8l12.9-65.8l-6.3-8.4c-0.3-0.6,0.1-1.3,0.9-1.3
	h19.8c1.1,0,1.7,0.7,1.4,1.7l-5.8,29c4.4-6.7,11.1-11.2,18.9-11.2c12.5,0,19.6,10.7,16.9,23.8l-6.4,31.9c-0.2,1.2-1.2,1.8-2,1.8
	h-11.7c-1.1,0-1.7-0.7-1.5-1.8l5.8-28.8c1.5-7.8-0.6-12.6-5.3-12.6c-8.9,0-15.9,10-18.9,24.1l-3.8,17.7c-0.1,0.7-0.7,1.3-1.5,1.3
	h-12.3C334.1,352.1,333.6,351.5,333.7,350.8L333.7,350.8z M333.7,350.8 M396.4,324.2c2.9-18.6,16-29.6,31.3-29.6
	c8.1,0,14.4,3.7,16.9,9.8l1.3-6.8c0.2-1.2,1.1-1.8,2.1-1.8h10.8c1.2,0,1.7,0.8,1.4,1.8l-10.3,52.8c-0.2,1-0.9,1.7-2.1,1.7h-10.9
	c-1,0-1.5-0.6-1.3-1.7l1-5.5c-5.1,5.8-11.4,8.7-18.3,8.7C402.6,353.7,393.8,340.7,396.4,324.2L396.4,324.2z M422.7,340.2
	c9,0,15.7-7.6,17-16.4c1.3-8.9-3.5-15.6-11.8-15.6c-8.9,0-15.3,7.2-16.8,15.7C409.7,332.5,414,340.2,422.7,340.2L422.7,340.2z
	 M422.7,340.2 M456.9,350.3l10.5-53c0.2-0.9,0.7-1.4,1.3-1.4h11.8c1,0,1.7,0.6,1.4,1.7l-1.2,6.9c4.2-6.1,10.3-9.8,16.5-9.8
	c3.1,0,6.5,1.2,8.2,2.9c1,1,1,1.6,0.3,2.6l-6.2,8.8c-0.8,1.1-1.4,1-2.6,0.4c-1.2-0.5-2.8-1-4.5-1c-7.4,0-13.7,4.9-16.5,19.7
	l-4.3,22.3c-0.3,1.5-1.5,1.8-2,1.8h-11.3C457.5,352.1,456.7,351.3,456.9,350.3L456.9,350.3z M456.9,350.3 M495.7,368.2
	c-0.7-0.5-0.7-1.4-0.2-2.2l5.2-8.2c0.6-0.9,1.4-1.1,2.1-0.6c5.1,3.2,10.1,5.2,16.2,5.2c10.7,0,19.6-4.3,22.7-18.7
	c-5.9,5.5-11.3,8.2-19.6,8.2c-16.1,0-24.5-13.5-21.9-28.7c3-17.1,15.8-28.7,31.9-28.7c8.9,0,15,5,16.9,9.1l1.3-6.1
	c0.2-1.2,1-1.8,1.9-1.8h10.9c1.1,0,1.7,0.7,1.5,1.8l-9.1,46.5c-4,20.2-18,30.8-37,30.8C510.5,374.9,501.5,372.9,495.7,368.2
	L495.7,368.2z M526.4,339c9,0,15.7-7.2,17-15.8c1.3-8.6-3.4-15-11.8-15c-8.9,0-15.3,7-16.8,15.1C513.4,331.6,517.7,339,526.4,339
	L526.4,339z M526.4,339 M565,323.6c2.9-17.4,15.7-28.9,32.3-28.9c16.9,0,24.9,13.5,22.4,28.1c-0.5,3.8-1.9,6.8-5,6.8h-36
	c0.3,8.2,6,12.1,13.6,12.1c5,0,9.7-1.9,13.2-4.2c0.9-0.7,1.9-1,2.5,0l4.1,6.4c0.7,1,0.3,1.7-0.7,2.6c-5.3,4.9-14,7.1-21.9,7.1
	C571.9,353.6,562.3,340.5,565,323.6L565,323.6z M606.9,319.8c0.5-8.8-5.5-12.5-11.2-12.5c-7.6,0-13.4,5.1-15.7,12.5H606.9z
	 M606.9,319.8 M308.8,353.7c7.5,0,14.8-2.1,21.5-8.4c1-0.9,1.1-2.1,0.4-2.8l-6.1-6.8c-0.6-0.7-1.5-0.7-2.2-0.1
	c-2.6,1.9-6.7,4.1-11.6,4.1c-8.8,0-13.7-6.9-12.6-15.5c1.1-8.6,7.9-15.5,16.5-15.5c4.7,0,7.7,1.7,11,5c0.9,0.9,1.4,0.9,2.4,0.1
	l7.9-6.8c0.8-0.7,1-1.4,0.4-2.3c-4.8-6.8-12.2-10-20.4-10c-16.6,0-30,12.3-32.2,28.7C281.4,341.1,293.2,353.7,308.8,353.7
	L308.8,353.7z M308.8,353.7"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'RechargeLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
